export default {
  "Content": "_Content_5hg4l_1",
  "SectionSplit": "_SectionSplit_5hg4l_7",
  "Instructions": "_Instructions_5hg4l_13"
};import "ni:sha-256;h-ITjfqbF119xOfR80KRGbrneD7PhLo3kf0oYdImLoY";